module.exports = __webpack_public_path__ + "static/media/arrowallmechiron.2c6a698b.svg";